import { r as registerInstance, c as createEvent, h, g as getElement, H as Host } from './index-d4808923.js';
import { b as bem, g as global$1, n as nextTick, h as hasNamedSlot } from './index.esm-7182addc.js';
import { a as attachObserverToInput } from './inputObserver-6de9a524.js';
import { g as getTextColor } from './getTextColor-1c68221e.js';
import { c as createPopper } from './popper-1604923e.js';
import { c as cloneDeep } from './index-167f81e8.js';
import { g as gravityXSSWhitelist, l as lib, x as xss } from './gravity-xss-whitelist-53c2079f.js';

const gravityCheckboxCss = ":host{display:flex}.gravity-checkbox{align-items:flex-start;display:flex;gap:8px;position:relative}.gravity-checkbox__checkmark{align-items:center;background-color:#FFFFFF;border:1px solid rgba(0, 15, 30, 0.2);border-radius:4px;box-sizing:border-box;cursor:pointer;display:flex;flex-shrink:0;font-size:12px;height:18px;justify-content:center;margin-top:3px;width:18px}.gravity-checkbox__label{cursor:pointer;display:flex;gap:8px;user-select:none;vertical-align:middle}.gravity-checkbox__label-highlighted{background-image:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDUgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgNkMwIDQuNjE5MjkgMS4xMTkyOSAzLjUgMi41IDMuNUMzLjg4MDcxIDMuNSA1IDQuNjE5MjkgNSA2QzUgNy4zODA3MSAzLjg4MDcxIDguNSAyLjUgOC41QzEuMTE5MjkgOC41IDAgNy4zODA3MSAwIDZaIiBmaWxsPSIjMUI2QUVFIi8+PC9zdmc+\");background-repeat:no-repeat;background-size:cover;display:inline-block;height:1em;margin-left:8px;margin-top:-2px;width:5px}.gravity-checkbox__input{height:0;opacity:0;position:absolute;width:0}.gravity-checkbox__input:focus-visible~.gravity-checkbox__checkmark{outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-checkbox__input:disabled+.gravity-checkbox__checkmark{border:1px solid rgba(0, 15, 30, 0.1);cursor:default}.gravity-checkbox__input:disabled~.gravity-checkbox__label{cursor:default}.gravity-checkbox__input:checked+.gravity-checkbox__checkmark,.gravity-checkbox__input:indeterminate+.gravity-checkbox__checkmark{background-color:#1B6AEE;border:1px solid #1B6AEE}.gravity-checkbox__input:checked:active+.gravity-checkbox__checkmark,.gravity-checkbox__input:checked:focus+.gravity-checkbox__checkmark,.gravity-checkbox__input:indeterminate:active+.gravity-checkbox__checkmark,.gravity-checkbox__input:indeterminate:focus+.gravity-checkbox__checkmark{background-color:#175ACA;border:1px solid #175ACA}.gravity-checkbox__input:checked:disabled+.gravity-checkbox__checkmark,.gravity-checkbox__input:indeterminate:disabled+.gravity-checkbox__checkmark{background-color:rgba(0, 15, 30, 0.1);border:1px solid transparent}.gravity-checkbox--size-small{gap:6px}.gravity-checkbox--size-small .gravity-checkbox__checkmark{height:16px;margin-top:1.5px;width:16px}.gravity-checkbox--size-small .gravity-checkbox__icon{--gravity-base-icon-size:12px}.gravity-checkbox--size-small .gravity-checkbox__label-highlighted{margin-left:6px}.gravity-checkbox:hover .gravity-checkbox__input:not([disabled])+.gravity-checkbox__checkmark{border:1px solid rgba(0, 15, 30, 0.45)}.gravity-checkbox:hover .gravity-checkbox__input:not([disabled]):checked+.gravity-checkbox__checkmark,.gravity-checkbox:hover .gravity-checkbox__input:not([disabled]):indeterminate+.gravity-checkbox__checkmark{background-color:#3279F0;border:1px solid #3279F0}";
const GravityCheckboxStyle0 = gravityCheckboxCss;

const generateClassNames = bem('gravity-checkbox');
const GravityCheckbox = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.changed = createEvent(this, "changed", 5);
        this.disabled = false;
        this.highlighted = false;
        this.label = '';
        this.size = 'medium';
        this.value = false;
    }
    handleValueChange() {
        if (this.input) {
            this.input.indeterminate = this.value === 'mixed';
        }
    }
    select() {
        this.value = this.input.checked;
        this.changed.emit(this.value);
    }
    renderIconForState() {
        if ('' + this.value === 'true') {
            return h("gravity-icon", { class: generateClassNames('icon'), color: "light", name: "check", size: "tiny" });
        }
        else if (this.value === 'mixed') {
            return h("gravity-icon", { class: generateClassNames('icon'), color: "light", name: "minus", size: "tiny" });
        }
        else {
            return '';
        }
    }
    componentDidLoad() {
        this.handleValueChange();
        /**
         * This is a temp fix for Last Pass issue of truthy attributes in input fields
         * for example: readonly="false" resolves to readonly
         * TODO: Remove this when Last Pass issue is fixed: https://github.com/redbullmediahouse/rbds-cosmos/issues/2951
         */
        attachObserverToInput(this.input, this.inputObserver);
    }
    render() {
        return (h("label", { key: '110a883fdf1a34c3adcd1c2dd3279927647d937b', class: generateClassNames({
                size: this.size,
            }) }, h("input", { key: 'b75930ac598eaceaa7d9f420ce65c74f84f782da', id: "checkbox", class: generateClassNames('input'), type: "checkbox", name: "checkbox", value: "checkbox", checked: '' + this.value === 'true', disabled: this.disabled, onClick: () => this.select(), ref: (el) => (this.input = el) }), h("span", { key: '8ec87ee562113ef15a0dbeb21977a23aa68a3d59', class: generateClassNames('checkmark') }, this.renderIconForState()), this.label ? (h("span", { class: generateClassNames('label') }, h("gravity-text", { size: this.size === 'medium' ? 'small' : 'x-small', color: getTextColor(this.disabled, this.highlighted) }, this.label, this.highlighted && h("span", { class: generateClassNames('label-highlighted') })))) : null));
    }
    static get watchers() { return {
        "value": ["handleValueChange"]
    }; }
};
GravityCheckbox.style = GravityCheckboxStyle0;

const gravityDropdownCss = ":host{display:block;outline:none;pointer-events:none;position:absolute;z-index:1000}:host([data-popper-placement^=right]) .gravity-dropdown{transform:translate(-8px, 0)}:host([data-popper-placement^=left]) .gravity-dropdown{transform:translate(8px, 0)}.gravity-dropdown{background-color:#FFFFFF;border:1px solid rgba(0, 15, 30, 0.2);border-radius:6px;box-shadow:0px 8px 12px 0px rgba(0, 15, 30, 0.0392156863), 0px 2px 4px 0px rgba(0, 15, 30, 0.0196078431);box-sizing:border-box;display:flex;flex-direction:column;opacity:0;pointer-events:none;text-align:left;transform-origin:50% top;transition:opacity 150ms cubic-bezier(0.32, 0, 0.32, 1);visibility:hidden;--gravity-dropdown-inner-prefix-size:var(--gravity-dropdown-prefix-size, 18px)}.gravity-dropdown__inner{max-width:calc(100vw - 2px);min-width:198px}.gravity-dropdown--size-small{--gravity-dropdown-inner-prefix-size:var(--gravity-dropdown-prefix-size, 16px);border-radius:4px}.gravity-dropdown--flipped{transform-origin:50% bottom}.gravity-dropdown--open{opacity:1;pointer-events:auto;transform:translate(0, 0) !important;visibility:visible}.gravity-dropdown--compact{overflow:hidden}.gravity-dropdown__view{transition:transform 150ms cubic-bezier(0.32, 0, 0.32, 1)}";
const GravityDropdownStyle0 = gravityDropdownCss;

const GravityDropdown = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.dropdownOptionSelected = createEvent(this, "dropdownOptionSelected", 5);
        this.isOpen = createEvent(this, "isOpen", 1);
        this.scrollEnd = createEvent(this, "scrollEnd", 5);
        this.searchChange = createEvent(this, "searchChange", 5);
        this.charWidthPerChar = 8.5; // average width per char
        this.generateClassNames = bem('gravity-dropdown');
        this.popperInstance = undefined;
        this.anchor = undefined;
        this.compact = false;
        this.disabled = false;
        this.flipBottom = false;
        this.for = '';
        this.maxHeight = 420;
        this.offset = 0;
        this.options = [];
        this.position = 'center';
        this.positionStrategy = 'absolute';
        this.queryType = false;
        this.scrollEndOffset = 1;
        this.searchBusy = false;
        this.searchPlaceholder = 'Search';
        this.selected = [];
        this.selectionBehavior = 'single';
        this.size = 'medium';
        this.width = 'auto';
        this.activeLevel = 0;
        this.activeSublevel = '';
        this.isRoot = false;
        this.open = false;
    }
    /**
     * Force Updates the position of the dropdown
     */
    async updatePosition() {
        if (this.popperInstance) {
            this.popperInstance.forceUpdate();
        }
    }
    /**
     * Open the dropdown
     */
    async openDropdown() {
        this.show();
    }
    handleWindowClick(event) {
        if (!this.open || this.isClickInside(event)) {
            return;
        }
        if (this.open) {
            this.hide();
        }
    }
    handleDropdownOptionSelected(event) {
        if (this.selectionBehavior) {
            this.selected = event.detail;
        }
        this.dropdownOptionSelected.emit(event.detail);
    }
    handleDropdownOptionClicked(event) {
        if (this.isRoot) {
            this.dropdownOptionSelected.emit([event.detail]);
        }
        else {
            this.dropdownOptionSelected.emit(event.detail);
        }
    }
    handleSublevelClick(event) {
        if (!this.compact) {
            return;
        }
        this.activeSublevel = event.detail;
        this.activeLevel = this.activeLevel + 1;
    }
    handleBackClick(event) {
        this.activeSublevel = event.detail;
        this.activeLevel = this.activeLevel - 1;
    }
    isClickInside(event) {
        const path = event.composedPath();
        return path.some((element) => element === this.triggerElement || element === this.anchorElement || element === this.element);
    }
    setListeners() {
        if (!this.triggerElement) {
            return;
        }
        this.triggerElement.onclick = () => {
            if (this.open) {
                this.hide();
                this.activeSublevel = '';
            }
            else if (!this.disabled) {
                this.show();
            }
        };
        this.triggerElement.onkeydown = (event) => {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                if (!this.open) {
                    this.show();
                }
            }
            else if (event.key === 'ArrowUp') {
                event.preventDefault();
                if (!this.open) {
                    this.show();
                }
            }
        };
        // NOTE: this is an ios safari workaround, without this the blur event is not firing when "clicked" away
        global$1.document.body.addEventListener('click', () => {
            return;
        });
    }
    show() {
        var _a;
        if (this.open) {
            return;
        }
        this.isOpen.emit(true);
        this.element.tabIndex = 0;
        this.element.focus();
        this.open = true;
        (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.update();
    }
    hide() {
        if (!this.open) {
            return;
        }
        this.element.tabIndex = -1;
        this.open = false;
        this.activeLevel = 0;
        this.isOpen.emit(false);
    }
    createPopUp() {
        var _a;
        if (!this.triggerElement) {
            return;
        }
        let placement = 'bottom';
        let flipModifier = {
            name: 'flip',
            options: {
                fallbackPlacements: this.flipBottom
                    ? ['bottom-start', 'bottom-end', 'top', 'top-start', 'top-end']
                    : ['bottom-start', 'bottom-end'],
            },
        };
        let offset = [0, 8 - this.offset];
        if (((_a = this.triggerElement) === null || _a === void 0 ? void 0 : _a.nodeName) === 'GRAVITY-DROPDOWN-OPTION') {
            placement = 'right-start';
            flipModifier = {
                name: 'flip',
                options: {
                    fallbackPlacements: ['left-start'],
                },
            };
            offset = [-1, 8];
        }
        else {
            switch (this.position) {
                case 'right':
                    placement = 'bottom-end';
                    flipModifier = {
                        name: 'flip',
                        options: {
                            fallbackPlacements: this.flipBottom ? ['bottom-start', 'top-end', 'top-start'] : ['bottom-start'],
                        },
                    };
                    break;
                case 'left':
                    placement = 'bottom-start';
                    flipModifier = {
                        name: 'flip',
                        options: {
                            fallbackPlacements: this.flipBottom ? ['bottom-end', 'top-start', 'top-end'] : ['bottom-end'],
                        },
                    };
                    break;
                case 'top':
                    placement = 'top';
                    flipModifier = {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['bottom'],
                        },
                    };
                    break;
            }
        }
        this.popperInstance = createPopper(this.anchorElement, this.element, {
            strategy: this.positionStrategy,
            placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset,
                    },
                },
                Object.assign({}, flipModifier),
            ],
        });
    }
    isFlipped() {
        return this.element.dataset.popperPlacement === 'top';
    }
    componentWillLoad() {
        var _a;
        this.triggerElement = this.for
            ? this.element.parentNode.querySelector(`#${this.for}`) || this.element.parentElement
            : this.element.parentElement;
        this.anchorElement = this.anchor ? this.element.parentNode.querySelector(`#${this.anchor}`) : this.triggerElement;
        this.isRoot = ((_a = this.triggerElement) === null || _a === void 0 ? void 0 : _a.nodeName) !== 'GRAVITY-DROPDOWN-OPTION';
    }
    componentDidLoad() {
        this.setListeners();
        this.createPopUp();
    }
    render() {
        return (h("div", { key: '9864d451966f0fe099f285410fb0135b5c63d132', class: this.generateClassNames({
                flipped: this.isFlipped(),
                open: this.open,
                compact: this.compact,
                size: this.size,
            }) }, h("div", { key: 'db43948a372da82b7a282ebf21dacb21d55028ff', class: this.generateClassNames('view'), style: { transform: `translateX(${-this.activeLevel * 100}%)` } }, h("gravity-dropdown-inner", { key: '393f1818cb0a5c13ae7186bc7b1fa7ef83dab553', class: this.generateClassNames('inner'), dropdown: this.element, visible: this.open || this.flipBottom, options: this.options, selected: this.selected, maxHeight: this.maxHeight, scrollEndOffset: this.scrollEndOffset, selectionBehavior: this.selectionBehavior, isRoot: this.isRoot, width: this.width, compact: this.compact, queryType: this.queryType, onHide: () => this.hide(), level: 0, activeLevel: this.activeLevel, activeSublevel: this.activeSublevel, keyboardNavigation: this.open, onSearchChange: (event) => this.searchChange.emit(event.detail), onDropdownOptionSelected: (event) => this.handleDropdownOptionSelected(event), onDropdownOptionClicked: (event) => this.handleDropdownOptionClicked(event), onScrollEnd: (event) => this.scrollEnd.emit(event.detail), onSublevelClick: (event) => this.handleSublevelClick(event), onBackClick: (event) => this.handleBackClick(event), size: this.size, searchPlaceholder: this.searchPlaceholder, searchBusy: this.searchBusy, ref: (el) => (this.dropdownInnerRef = el), triggerElement: this.triggerElement }))));
    }
    get element() { return getElement(this); }
};
GravityDropdown.style = GravityDropdownStyle0;

const gravityDropdownInnerCss = ":host{display:block;position:relative}.gravity-dropdown-inner{border-radius:6px;flex-direction:column;height:100%;overflow:hidden;transform:translate3d(0, 0, 0)}.gravity-dropdown-inner .gravity-dropdown-inner__options__option:last-child{--gravity-dropdown-option-border-bottom:none}.gravity-dropdown-inner__options{flex:1 1 auto;overflow-y:auto;position:relative;width:100%}.gravity-dropdown-inner__options__data{width:100%}.gravity-dropdown-inner__options__option{--option-gap:2px;box-sizing:border-box;left:4px;padding-top:var(--option-gap);position:absolute;width:calc(100% - 8px)}.gravity-dropdown-inner--size-small .gravity-dropdown-inner__options__option{left:2px;width:calc(100% - 4px)}.gravity-dropdown-inner:not(.gravity-dropdown-inner--size-small) .gravity-dropdown-inner__options__option:first-child{--option-gap:4px}.gravity-dropdown-inner__options__dummy-option{clip:rect(0, 0, 0, 0);height:0;pointer-events:none;position:absolute;visibility:hidden}.gravity-dropdown-inner__options__group-header{--group-header-spacing-medium:4px;--group-header-spacing-small:2px;align-items:center;box-sizing:border-box;display:flex;height:100%;left:var(--group-header-spacing-medium);padding-block:calc(12px + var(--group-header-spacing-medium)) 4px;padding-inline:12px;position:absolute;width:calc(100% - var(--group-header-spacing-medium) * 2)}.gravity-dropdown-inner--size-small .gravity-dropdown-inner__options__group-header{left:var(--group-header-spacing-small);padding-block:calc(8px + var(--group-header-spacing-small)) 4px;padding-inline:8px;width:calc(100% - var(--group-header-spacing-small) * 2)}.gravity-dropdown-inner__options__group-header:not(:first-child)::before{background-color:rgba(0, 15, 30, 0.1);content:\"\";height:1px;left:calc(var(--group-header-spacing-medium) * -1);position:absolute;right:calc(var(--group-header-spacing-medium) * -1);top:-1px}.gravity-dropdown-inner--size-small .gravity-dropdown-inner__options__group-header:not(:first-child)::before{left:calc(var(--group-header-spacing-small) * -1);right:calc(var(--group-header-spacing-small) * -1)}.gravity-dropdown-inner__option__prefix{align-items:center;display:flex;flex:1 0 auto;justify-content:left;margin-right:6px;--gravity-flag-width:var(--gravity-dropdown-inner-prefix-size);--gravity-base-icon-size:var(--gravity-dropdown-inner-prefix-size)}.gravity-dropdown-inner--size-small .gravity-dropdown-inner__option__prefix{margin-right:4px}.gravity-dropdown-inner__search{background:#FFFFFF;border-bottom:4px solid #FFFFFF;border-top:4px solid #FFFFFF;flex:0 0 auto;overflow:hidden;--gravity-input-border-top:none;--gravity-input-border-right:none;--gravity-input-border-bottom:none;--gravity-input-border-left:none;--gravity-input-border-radius:initial}.gravity-dropdown-inner--size-small .gravity-dropdown-inner__search{border-width:2px}.gravity-dropdown-inner__search+.gravity-dropdown-inner__options,.gravity-dropdown-inner__search+.gravity-dropdown-inner__empty-message{border-top:1px solid rgba(0, 15, 30, 0.05)}.gravity-dropdown-inner__empty-message{padding:16px 16px 32px}.gravity-dropdown-inner__empty-message__text{display:block}.gravity-dropdown-inner__empty-message__text:first-child{margin-bottom:4px}.gravity-dropdown-inner__header ::slotted(div:first-of-type){background-color:#F8F8F8;padding:8px 12px}.gravity-dropdown-inner--size-small .gravity-dropdown-inner__header ::slotted(div:first-of-type){padding:8px}";
const GravityDropdownInnerStyle0 = gravityDropdownInnerCss;

const GravityDropdownInner = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.backClick = createEvent(this, "backClick", 1);
        this.dropdownOptionClicked = createEvent(this, "dropdownOptionClicked", 1);
        this.dropdownOptionSelected = createEvent(this, "dropdownOptionSelected", 1);
        this.hide = createEvent(this, "hide", 1);
        this.scrollEnd = createEvent(this, "scrollEnd", 3);
        this.searchChange = createEvent(this, "searchChange", 3);
        this.sublevelClick = createEvent(this, "sublevelClick", 1);
        this.generateClassNames = bem('gravity-dropdown-inner');
        this.previousScrollTop = 0;
        this.xssOptions = {
            whiteList: Object.assign(Object.assign({}, gravityXSSWhitelist), lib.exports.whiteList),
        };
        this.longestOption = null;
        this.handleScroll = (event) => {
            const target = event.target;
            const { clientHeight, scrollTop, scrollHeight } = target;
            this.isScrollStopped = false;
            clearTimeout(this.scrollStopTimeout);
            this.scrollStopTimeout = setTimeout(() => {
                this.isScrollStopped = true;
            }, 100);
            if (this.isScrollNearBottom(clientHeight, scrollTop, scrollHeight)) {
                this.scrollEnd.emit();
            }
            this.updateRenderedOptions(scrollTop);
            this.previousScrollTop = scrollTop;
        };
        this.handleTriggerKeydown = (event) => {
            var _a, _b;
            const { key } = event;
            if (key === 'Escape' && this.visible) {
                event.stopPropagation();
                if (this.selectionBehavior === 'multi' && this.compact) {
                    this.backClick.emit((_b = (_a = this.backOption) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '');
                }
                else {
                    this.hide.emit();
                }
                return;
            }
            // Only handle other keys if no active index
            if (this.activeIndex !== -1) {
                return;
            }
            event.stopPropagation();
            switch (key) {
                case 'ArrowDown':
                case 'ArrowUp': {
                    event.preventDefault();
                    key === 'ArrowDown' ? this.activateFirstIndex() : this.activateLastIndex();
                    break;
                }
                case 'Enter':
                case ' ': {
                    this.activateFirstIndex();
                    break;
                }
            }
        };
        this.resetActiveIndex = () => {
            this.activeIndex = -1;
        };
        this.handleDropdownBlur = () => {
            var _a;
            // Reset the active index if the dropdown loses focus, remains visible in DOM, and the current option lacks a sublevel
            // (e.g., when switching filters in gravity-filter-sidebar)
            if (this.isVisible && !((_a = this.filteredOptions[this.activeIndex]) === null || _a === void 0 ? void 0 : _a.sublevel)) {
                this.resetActiveIndex();
            }
        };
        this.activateFirstIndex = () => {
            if (this.activeIndex === -1) {
                this.activeIndex = 0;
            }
            const optionsContainerElement = this.getOptionsContainerElement();
            if (optionsContainerElement) {
                optionsContainerElement.scrollTop = 0;
            }
        };
        this.activeLevel = undefined;
        this.activeSublevel = undefined;
        this.backOption = undefined;
        this.compact = false;
        this.dropdown = undefined;
        this.isRoot = false;
        this.keyboardNavigation = true;
        this.level = undefined;
        this.maxHeight = 420;
        this.option = undefined;
        this.options = [];
        this.queryType = false;
        this.scrollEndOffset = 1;
        this.searchBusy = false;
        this.searchPlaceholder = undefined;
        this.selected = [];
        this.selectionBehavior = 'single';
        this.size = 'medium';
        this.triggerElement = undefined;
        this.visible = true;
        this.width = 'auto';
        this.activeIndex = -1;
        this.delayedSearchTerm = undefined;
        this.filteredOptions = undefined;
        this.isScrollStopped = true;
        this.isVisible = this.visible;
        this.renderedOptions = undefined;
        this.renderIndexOffset = 0;
        this.totalOptionsHeight = undefined;
    }
    watchOptionsHandler() {
        this.setSelectionBehaviour();
        this.longestOption = this.findLongestOption();
    }
    handleFilteredOptionsChange() {
        this.totalOptionsHeight = this.calculateTotalOptionsHeight();
        this.updateRenderedOptions();
    }
    handleVisibleChange(value) {
        var _a;
        clearTimeout(this.showTimeout);
        if (value) {
            this.isVisible = value;
            if (this.queryType) {
                setTimeout(() => {
                    void this.searchElement.inputFocus();
                }, 100);
            }
            const shouldActivateFirstIndex = !this.isRoot || ((_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.tagName) === 'GRAVITY-SELECT';
            if (shouldActivateFirstIndex) {
                this.activateFirstIndex();
            }
        }
        else {
            this.showTimeout = setTimeout(() => {
                this.isVisible = value;
            }, 300);
            this.resetActiveIndex();
        }
    }
    handleTriggerElementChange(triggerElement) {
        triggerElement === null || triggerElement === void 0 ? void 0 : triggerElement.addEventListener('keydown', this.handleTriggerKeydown);
    }
    handleSizeChange() {
        this.setDropdownWidth();
    }
    getOptionHeight(index) {
        const baseHeight = this.size === 'small' ? 32 : 40;
        let paddingTop = 2;
        if (this.size === 'medium' && index === 0) {
            paddingTop += 2;
        }
        return baseHeight + paddingTop;
    }
    getGroupHeaderHeight() {
        const baseHeight = this.size === 'small' ? 28 : 32;
        const paddingTop = this.size === 'small' ? 2 : 4;
        return baseHeight + paddingTop;
    }
    getLastOptionHeight(index) {
        const baseHeight = this.size === 'small' ? 32 : 40;
        const paddingTop = 2;
        const defaultPaddingBottom = this.size === 'small' ? 2 : 4;
        const extraGroupPadding = 3;
        const isLastOptionOverall = index === this.filteredOptions.length - 1;
        const paddingBottom = isLastOptionOverall ? defaultPaddingBottom : defaultPaddingBottom + extraGroupPadding;
        return baseHeight + paddingTop + paddingBottom;
    }
    getOptionHeightByIndex(index) {
        const option = this.filteredOptions[index];
        const optionHeight = option.options ? this.getGroupHeaderHeight() : this.getOptionHeight(index);
        const isLastInGroup = !this.filteredOptions[index + 1] || this.filteredOptions[index + 1].options !== undefined;
        return isLastInGroup ? this.getLastOptionHeight(index) : optionHeight;
    }
    updateRenderedOptions(scrollTop) {
        var _a;
        if (scrollTop === void 0) {
            scrollTop = ((_a = this.optionsListElement) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0;
        }
        const bufferItems = 2;
        const { firstVisibleIndex, lastVisibleIndex } = this.calculateOptionRangeIndices(scrollTop);
        const startIndex = Math.max(0, firstVisibleIndex - bufferItems);
        const endIndex = Math.min(this.filteredOptions.length, lastVisibleIndex + bufferItems);
        this.renderIndexOffset = this.calculateTopOffset(startIndex);
        this.renderedOptions = this.filteredOptions.slice(startIndex, endIndex + 1); // +1 to include the last option
    }
    calculateOptionRangeIndices(scrollTop) {
        let accumulatedHeight = 0;
        const maxVisibleHeight = scrollTop + this.maxHeight;
        let firstVisibleIndex = 0;
        let lastVisibleIndex = this.filteredOptions.length - 1;
        for (let i = 0; i < this.filteredOptions.length; i++) {
            const optionHeight = this.getOptionHeightByIndex(i);
            if (accumulatedHeight <= scrollTop) {
                firstVisibleIndex = i;
            }
            accumulatedHeight += optionHeight;
            if (accumulatedHeight > maxVisibleHeight) {
                lastVisibleIndex = i;
                break;
            }
        }
        return { firstVisibleIndex, lastVisibleIndex };
    }
    calculateTopOffset(startIndex) {
        let topOffset = 0;
        for (let i = 0; i < startIndex; i++) {
            topOffset += this.getOptionHeightByIndex(i);
        }
        return topOffset;
    }
    calculateTotalOptionsHeight() {
        return this.filteredOptions.reduce((totalHeight, _, index) => totalHeight + this.getOptionHeightByIndex(index), 0);
    }
    renderOptionsList() {
        var _a;
        let currentTop = 0;
        const renderOption = (option) => {
            var _a;
            const actualOptionIndex = this.filteredOptions.indexOf(option);
            const height = this.getOptionHeightByIndex(actualOptionIndex);
            const top = this.renderIndexOffset + currentTop;
            currentTop += height;
            let sublevelType = false;
            if ((_a = option.sublevel) === null || _a === void 0 ? void 0 : _a.options) {
                sublevelType = option.sublevel.options.length > 0 || !!option.sublevel.queryType ? 'standard' : 'empty';
            }
            if (option.options) {
                return (h("div", { class: this.generateClassNames('options__group-header'), key: `group-${option.id}`, style: { top: `${top}px`, height: `${height}px` } }, h("gravity-text", { class: this.generateClassNames('options__group-option__text'), color: "dark-subtle", size: "xx-small", weight: "medium" }, option.label)));
            }
            return (h("gravity-dropdown-option", { active: this.optionIsActive(option.id), class: this.generateClassNames('options__option'), danger: option.danger, disabled: option.disabled, id: `option-${option.id}`, key: `option-${option.id}`, meta: option.meta, multi: this.selectionBehavior === 'multi', onClick: () => this.handleOptionClicked(option), onMouseLeave: () => this.resetActiveIndex(), onMouseOver: () => this.handleHover(option.id), optionId: option.id, optionTitle: option.label, selected: this.optionSelected(option.id), size: this.size, style: {
                    top: `${top}px`,
                    height: `${height}px`,
                }, sublevel: sublevelType }, option.prefix && (h("span", { class: this.generateClassNames('option__prefix'), innerHTML: xss(option.prefix, this.xssOptions), slot: "prefix" }))));
        };
        return (h("div", { class: `${this.generateClassNames('options')} dropdown__options`, ref: (el) => (this.optionsListElement = el) }, h("div", { class: this.generateClassNames('options__data'), style: { height: `${this.totalOptionsHeight}px` } }, (_a = this.renderedOptions) === null || _a === void 0 ? void 0 : _a.map((option) => renderOption(option)))));
    }
    setScrollListener() {
        this.optionsListElement.addEventListener('scroll', this.handleScroll);
    }
    setInitialRenderOptions() {
        this.filteredOptions = cloneDeep(this.options)
            .map((option) => (option.options ? [option, ...option.options] : option))
            .flat();
    }
    optionSelected(id) {
        return this.selected ? this.selected.includes(id) : false;
    }
    optionIsActive(id) {
        return this.activeIndex === this.filteredOptions.findIndex((option) => option.id === id);
    }
    handleHover(id) {
        if (this.isVisible) {
            this.activeIndex = this.filteredOptions.findIndex((option) => option.id === id);
        }
    }
    computeSelectionBehavior(option) {
        var _a;
        if (option.sublevel && option.sublevel.multiSelect) {
            return 'multi';
        }
        else if (((_a = option.sublevel) === null || _a === void 0 ? void 0 : _a.selectionBehavior) !== undefined) {
            return option.sublevel.selectionBehavior;
        }
        else if (this.selectionBehavior) {
            return 'single';
        }
        else {
            return false;
        }
    }
    computeQueryType(option) {
        var _a;
        if (option.sublevel && option.sublevel.searchable) {
            return 'filter';
        }
        else if ((_a = option.sublevel) === null || _a === void 0 ? void 0 : _a.queryType) {
            return option.sublevel.queryType;
        }
        return false;
    }
    setSelectionBehaviour() {
        this.delayedSearchTerm = this.searchTerm;
        if (JSON.stringify(this.originalOptions) == JSON.stringify(this.options) && this.queryType != 'custom') {
            return;
        }
        this.originalOptions = cloneDeep(this.options);
        this.filteredOptions = cloneDeep(this.options)
            .map((option) => (option.options ? [option, ...option.options] : option))
            .flat();
    }
    getFilteredOptions(searchTerm) {
        const firstShowingIndex = this.optionsListElement
            ? Math.floor(this.optionsListElement.scrollTop / this.getOptionHeight(0))
            : 0;
        const clonedOptions = cloneDeep(this.options);
        const lowerSearchTerm = searchTerm.toLowerCase();
        const flattenOptions = (options) => options.map((option) => (option.options ? [option, ...option.options] : option)).flat();
        if (!searchTerm) {
            this.filteredOptions = flattenOptions(clonedOptions);
            this.renderedOptions = this.filteredOptions.slice(firstShowingIndex);
            return;
        }
        this.filteredOptions = clonedOptions.filter((option) => {
            if (option.options) {
                const filterOptions = (options) => options.filter((option) => option.label.toLowerCase().includes(lowerSearchTerm));
                const matchingSubOptions = filterOptions(option.options);
                option.options = matchingSubOptions;
                return matchingSubOptions.length > 0;
            }
            return option.label.toLowerCase().includes(lowerSearchTerm);
        });
        // Flatten the filtered options array
        this.filteredOptions = flattenOptions(this.filteredOptions);
    }
    handleSearchChange(event) {
        event.stopPropagation();
        this.searchTerm = event.detail;
        if (this.queryType === 'filter') {
            this.getFilteredOptions(this.searchTerm);
        }
        const hasSublevelQuery = JSON.stringify(this.options).match(/(sublevel(.*)queryType)/);
        if (hasSublevelQuery && this.isRoot) {
            this.searchChange.emit({
                id: 'root',
                query: this.searchTerm,
            });
        }
        else {
            this.searchChange.emit(this.searchTerm);
        }
    }
    handleOptionClicked(option) {
        if (option.sublevel) {
            this.sublevelClick.emit(option.id);
            return;
        }
        const selectedSet = new Set(this.selected);
        switch (this.selectionBehavior) {
            case 'single': {
                this.selected = [option.id];
                this.hide.emit();
                this.dropdownOptionSelected.emit(this.selected);
                break;
            }
            case 'multi': {
                selectedSet.has(option.id) ? selectedSet.delete(option.id) : selectedSet.add(option.id);
                this.selected = Array.from(selectedSet);
                this.dropdownOptionSelected.emit(this.selected);
                break;
            }
            default: {
                this.dropdownOptionClicked.emit(option.id);
                this.hide.emit();
                break;
            }
        }
    }
    isScrollNearBottom(clientHeight, scrollTop, scrollHeight) {
        return (this.previousScrollTop + clientHeight < scrollHeight - this.scrollEndOffset &&
            scrollTop + clientHeight >= scrollHeight - this.scrollEndOffset);
    }
    setKeyboardListener() {
        if (!this.dropdown) {
            return;
        }
        this.dropdown.addEventListener('keydown', (event) => {
            const { key } = event;
            // Handle Escape key first
            if (key === 'Escape' && this.visible) {
                event.stopPropagation();
                if (this.selectionBehavior == 'multi' && this.compact) {
                    this.backClick.emit(this.backOption ? this.backOption.id : '');
                }
                else {
                    this.hide.emit();
                }
                return;
            }
            // Skip other keyboard navigation if not in correct sublevel/level
            if ((this.option && this.option.id !== this.activeSublevel) || this.level != this.activeLevel) {
                return;
            }
            if (key === 'ArrowUp' || key === 'ArrowDown' || (key === ' ' && this.queryType === false)) {
                event.preventDefault();
            }
            const isSpaceBarClick = key === ' ' && this.queryType === false;
            const isClicking = key === 'Enter' || isSpaceBarClick || (key === 'Tab' && this.selectionBehavior === 'single');
            if (this.keyboardNavigation) {
                if (isClicking && this.visible && this.selectionBehavior != 'multi') {
                    event.preventDefault();
                    this.performDeepClickOnActiveOption();
                    this.dropdown.focus();
                }
                else if (isClicking && this.visible && this.selectionBehavior == 'multi') {
                    this.performDeepClickOnActiveOption();
                }
                else {
                    this.handleKeyNavigation(event);
                }
            }
        });
    }
    getSubOptionsSelected(subOptionId) {
        return this.selected
            .filter((selectedId) => selectedId.includes(`${subOptionId}.`))
            .map((id) => {
            const split = id.split('.');
            return split.slice(split.indexOf(subOptionId) + 1, split.length).join('.');
        });
    }
    subOptionSelected(event, option) {
        var _a, _b;
        event.stopPropagation();
        const newSelectedIds = event.detail;
        const sublevelBehavior = (_b = (_a = option.sublevel) === null || _a === void 0 ? void 0 : _a.selectionBehavior) !== null && _b !== void 0 ? _b : this.selectionBehavior;
        const optionPrefix = `${option.id}.`;
        switch (sublevelBehavior) {
            case 'single':
                this.selected = newSelectedIds.map((id) => `${optionPrefix}${id}`);
                this.dropdownOptionSelected.emit(this.selected);
                break;
            case 'multi': {
                const prefixedNewSelectedIds = new Set(newSelectedIds.map((id) => `${optionPrefix}${id}`));
                this.selected = this.selected
                    .filter((id) => !id.startsWith(optionPrefix))
                    .concat(Array.from(prefixedNewSelectedIds));
                this.dropdownOptionSelected.emit(this.selected);
                break;
            }
            default:
                this.dropdownOptionClicked.emit(newSelectedIds);
                this.hide.emit();
        }
    }
    handleSublevelScrollEnd(event, option) {
        event.stopPropagation();
        this.scrollEnd.emit({
            id: option.id,
        });
    }
    handleSublevelSearchChange(event, option) {
        event.stopPropagation();
        this.searchChange.emit({
            id: option.id,
            query: event.detail,
        });
    }
    handleKeyNavigation(event) {
        var _a, _b;
        event.stopPropagation();
        if (event.key === 'ArrowDown' && this.activeIndex < this.filteredOptions.length - 1) {
            if (this.filteredOptions[this.activeIndex + 1].options && ((_a = this.filteredOptions[this.activeIndex + 2]) === null || _a === void 0 ? void 0 : _a.id)) {
                this.activeIndex += 2;
            }
            else if (!this.filteredOptions[this.activeIndex + 1].options) {
                this.activeIndex++;
            }
            this.checkAndMoveIntoView();
        }
        else if (event.key === 'ArrowUp' && this.activeIndex > 0) {
            if (this.filteredOptions[this.activeIndex - 1].options && ((_b = this.filteredOptions[this.activeIndex - 2]) === null || _b === void 0 ? void 0 : _b.id)) {
                this.activeIndex -= 2;
            }
            else if (!this.filteredOptions[this.activeIndex - 1].options) {
                this.activeIndex--;
            }
            this.checkAndMoveIntoView();
        }
        else if (event.key === 'ArrowRight' && this.filteredOptions[this.activeIndex].sublevel) {
            this.performClickOnActiveOption();
        }
        else if (event.key === 'ArrowLeft' && !this.isRoot) {
            if (this.compact) {
                this.backClick.emit(this.backOption ? this.backOption.id : '');
            }
            else {
                this.hide.emit();
            }
        }
    }
    performClickOnActiveOption() {
        if (this.activeIndex !== -1) {
            this.element.shadowRoot.getElementById(`option-${this.filteredOptions[this.activeIndex].id}`).click();
        }
    }
    performDeepClickOnActiveOption() {
        if (this.activeIndex !== -1) {
            const activeOption = this.filteredOptions[this.activeIndex];
            // Only perform the click if the option has no sublevel
            if (!activeOption.sublevel) {
                const dropdownOption = this.element.shadowRoot.getElementById(`option-${activeOption.id}`);
                dropdownOption.shadowRoot.querySelector('div').click();
                // Hide the sublevel if it's not multi-select
                if (this.selectionBehavior !== 'multi') {
                    this.hide.emit();
                }
            }
        }
    }
    checkAndMoveIntoView() {
        const activeOptionElement = this.getActiveOptionElement();
        if (!activeOptionElement)
            return;
        const optionsContainerElement = this.getOptionsContainerElement();
        if (!optionsContainerElement)
            return;
        const relativeTopPosition = this.calculateRelativeTopPosition(activeOptionElement, optionsContainerElement);
        const containerHeight = optionsContainerElement.getBoundingClientRect().height;
        if (this.isOptionOutOfViewAbove(relativeTopPosition)) {
            activeOptionElement.scrollIntoView({ block: 'start' });
        }
        else if (this.isOptionOutOfViewBelow(relativeTopPosition, containerHeight)) {
            activeOptionElement.scrollIntoView({ block: 'end' });
        }
    }
    getActiveOptionElement() {
        return this.element.shadowRoot.getElementById(`option-${this.filteredOptions[this.activeIndex].id}`);
    }
    getOptionsContainerElement() {
        return this.element.shadowRoot.querySelector('.dropdown__options');
    }
    calculateRelativeTopPosition(activeOptionElement, optionsContainerElement) {
        const optionRect = activeOptionElement.getBoundingClientRect();
        const containerRect = optionsContainerElement.getBoundingClientRect();
        return optionRect.top - containerRect.top;
    }
    isOptionOutOfViewAbove(relativeTopPosition) {
        return relativeTopPosition < 0;
    }
    isOptionOutOfViewBelow(relativeTopPosition, containerHeight) {
        const offset = this.queryType ? 133 : 59;
        return relativeTopPosition > containerHeight - offset;
    }
    async activateLastIndex() {
        if (this.activeIndex === -1) {
            this.activeIndex = this.filteredOptions.length - 1;
        }
        await nextTick(); // First nextTick required to get the accurate scrollHeight
        await nextTick(); // Second nextTick required for long virtual scroll lists
        const optionsContainerElement = this.getOptionsContainerElement();
        if (optionsContainerElement) {
            optionsContainerElement.scrollTop = optionsContainerElement.scrollHeight;
        }
    }
    findLongestOption() {
        let longest = null;
        let maxLength = 0;
        const flatOptions = this.options.flatMap((option) => [option, ...(option.options || [])]);
        for (const option of flatOptions) {
            if (option.label.length > maxLength) {
                longest = option;
                maxLength = option.label.length;
            }
        }
        return longest;
    }
    renderDropdownInner() {
        return (h("div", { class: this.generateClassNames({
                [`size-${this.size}`]: true,
            }), style: {
                transform: `translateX(${this.level * 100}%)`,
                display: this.isVisible ? 'flex' : 'none',
                position: this.level === this.activeLevel ? 'static' : 'absolute',
            } }, this.renderHeaderSlot(), this.queryType && this.renderSearchBar(), this.renderCompactBackOption(), this.renderEmptyMessage(), this.renderOptionsList()));
    }
    renderSubDropdowns() {
        var _a;
        if (!this.isScrollStopped || this.compact) {
            return;
        }
        return (_a = this.renderedOptions) === null || _a === void 0 ? void 0 : _a.map((option) => [
            option.sublevel && !option.disabled && (option.sublevel.options.length > 0 || !!option.sublevel.queryType) && (h("gravity-dropdown", { options: option.sublevel.options, id: `sublevel-${option.id}`, key: `sublevel-${option.id}`, for: `option-${option.id}`, "query-type": this.computeQueryType(option), maxHeight: option.sublevel.maxHeight, selected: this.getSubOptionsSelected(option.id), width: this.width, onDropdownOptionSelected: (event) => this.subOptionSelected(event, option), selectionBehavior: this.computeSelectionBehavior(option), onSearchChange: (event) => this.handleSublevelSearchChange(event, option), onScrollEnd: (event) => this.handleSublevelScrollEnd(event, option), size: this.size })),
        ]);
    }
    renderCompactSublevels() {
        if (!this.compact) {
            return;
        }
        return this.options.map((option) => [
            option.sublevel && (option.sublevel.options.length > 0 || !!option.sublevel.queryType) && (h("gravity-dropdown-inner", { id: `sublevel-${option.id}`, key: `sublevel-${option.id}`, dropdown: this.dropdown, visible: this.activeSublevel == option.id, options: option.sublevel.options, queryType: this.computeQueryType(option), maxHeight: option.sublevel.maxHeight, selected: this.getSubOptionsSelected(option.id), width: this.width, option: option, backOption: this.option, isRoot: false, compact: this.compact, level: this.level + 1, activeLevel: this.activeLevel, activeSublevel: this.activeSublevel, size: this.size, selectionBehavior: this.computeSelectionBehavior(option), onDropdownOptionSelected: (event) => this.subOptionSelected(event, option), onDropdownOptionClicked: (event) => this.dropdownOptionClicked.emit(event.detail), onSearchChange: (event) => this.handleSublevelSearchChange(event, option), onScrollEnd: (event) => this.scrollEnd.emit(event.detail), onBackClick: (event) => this.backClick.emit(event.detail), onSublevelClick: (event) => this.sublevelClick.emit(event.detail) })),
        ]);
    }
    renderSearchBar() {
        return (h("div", { class: this.generateClassNames('search') }, h("gravity-search", { size: this.size, type: "search-bar", onSearchChange: (event) => this.handleSearchChange(event), ref: (el) => (this.searchElement = el), busy: this.searchBusy, placeholder: this.searchPlaceholder })));
    }
    renderHeaderSlot() {
        return (hasNamedSlot(this.element, 'header') && (h("div", { class: this.generateClassNames('header') }, h("slot", { name: "header" }))));
    }
    renderCompactBackOption() {
        const shouldRenderBackOption = this.backOption || this.level === 1;
        if (!shouldRenderBackOption) {
            return;
        }
        const optionTitle = this.backOption ? this.backOption.label : 'Back';
        const backOptionId = this.backOption ? this.backOption.id : '';
        // Calculate the same height as regular options to ensure consistency
        const baseHeight = this.size === 'small' ? 32 : 40;
        const paddingTop = 2;
        const height = baseHeight + paddingTop;
        return (h("div", { class: this.generateClassNames('options__option'), style: { position: 'relative', height: `${height}px` } }, h("gravity-dropdown-option", { id: `option-back`, optionId: `option-id`, optionTitle: optionTitle, size: this.size, onClick: () => this.backClick.emit(backOptionId) }, h("gravity-icon", { name: "arrow-left", color: "dark-subtle", size: "xx-small", slot: "prefix" }))));
    }
    renderEmptyMessage() {
        if (this.queryType == 'custom' && this.filteredOptions.length == 0) {
            if (this.delayedSearchTerm) {
                return (h("div", { class: this.generateClassNames('empty-message') }, h("gravity-heading", { class: this.generateClassNames('empty-message__text'), size: "small" }, "Your search didn\u2019t return any results."), h("gravity-text", { class: this.generateClassNames('empty-message__text'), type: "multiline" }, "Please check your spelling or try another search term.")));
            }
            else {
                return (h("div", { class: this.generateClassNames('empty-message') }, h("gravity-heading", { class: this.generateClassNames('empty-message__text'), size: "small" }, "Please enter a search term."), h("gravity-text", { class: this.generateClassNames('empty-message__text'), type: "multiline" }, "We will suggest results based on your input.")));
            }
        }
    }
    /**
     * Renders a hidden dummy option using the option with the longest label.
     * This is used to determine the minimum width of the dropdown to ensure
     * all options are properly displayed without truncation.
     */
    renderDummyOption() {
        if (this.width === 'auto' && this.longestOption) {
            return (h("gravity-dropdown-option", { "aria-hidden": "true", class: this.generateClassNames('options__dummy-option'), meta: this.longestOption.meta, multi: this.selectionBehavior === 'multi', optionTitle: this.longestOption.label, ref: (el) => (this.dummyOptionRef = el), selected: this.optionSelected(this.longestOption.id), size: this.size }, this.longestOption.prefix && (h("span", { class: this.generateClassNames('option__prefix'), innerHTML: xss(this.longestOption.prefix, this.xssOptions), slot: "prefix" }))));
        }
    }
    async setDropdownWidth() {
        const optionMarginInline = this.size === 'medium' ? 8 : 4;
        const dropdownBorderWidth = 2;
        const autoWidthBuffer = 6;
        const scrollbarWidth = this.totalOptionsHeight > this.maxHeight ? 16 : 4;
        if (this.width === 'auto' && this.dummyOptionRef) {
            // Force synchronous reflow on dummy option
            await nextTick();
            const dummyOptionWidth = Math.ceil(this.dummyOptionRef.getBoundingClientRect().width);
            const totalWidth = dummyOptionWidth + optionMarginInline + scrollbarWidth + autoWidthBuffer;
            if (!this.isRoot && !this.compact) {
                this.element.style.width = `${totalWidth}px`;
            }
            return;
        }
        if (this.width === 'anchor' && this.triggerElement) {
            await nextTick();
            const anchorWidth = Math.ceil(this.triggerElement.getBoundingClientRect().width);
            this.element.style.width = `${anchorWidth - dropdownBorderWidth}px`;
            return;
        }
        const fixedWidth = parseInt(this.width);
        if (!isNaN(fixedWidth)) {
            await nextTick();
            this.element.style.width = `${fixedWidth - dropdownBorderWidth}px`;
        }
    }
    componentWillLoad() {
        this.setInitialRenderOptions();
        this.setSelectionBehaviour();
        this.longestOption = this.findLongestOption();
    }
    componentDidLoad() {
        var _a;
        this.setScrollListener();
        this.setKeyboardListener();
        // to prevent the blur event firing when interacting with footer we prevent the mousedown event
        this.element.onmousedown = (event) => {
            event.preventDefault();
        };
        (_a = this.triggerElement) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', this.handleTriggerKeydown);
        this.setDropdownWidth();
    }
    componentDidRender() {
        const offset = 10;
        if (this.queryType) {
            const searchHeight = this.size === 'medium' ? 56 : 48;
            const searchHeightWithOffset = searchHeight + offset;
            this.optionsListElement.style.maxHeight = `${Math.max(this.maxHeight - searchHeightWithOffset, 0)}px`;
        }
        else {
            this.optionsListElement.style.maxHeight = `${Math.max(this.maxHeight - offset, 0)}px`;
        }
    }
    disconnectedCallback() {
        var _a;
        this.optionsListElement.removeEventListener('scroll', this.handleScroll);
        (_a = this.triggerElement) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', this.handleTriggerKeydown);
    }
    render() {
        return (h(Host, { key: 'f699de5ec3bff81ae335ac7b62bd26ee64a0e9d6', onBlur: this.handleDropdownBlur }, this.renderDropdownInner(), this.renderSubDropdowns(), this.renderCompactSublevels(), this.renderDummyOption()));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "options": ["watchOptionsHandler", "handleSizeChange"],
        "filteredOptions": ["handleFilteredOptionsChange"],
        "visible": ["handleVisibleChange"],
        "triggerElement": ["handleTriggerElementChange"],
        "size": ["handleSizeChange"],
        "width": ["handleSizeChange"]
    }; }
};
GravityDropdownInner.style = GravityDropdownInnerStyle0;

const gravityDropdownOptionCss = ".gravity-dropdown-option{align-items:center;background-color:#FFFFFF;border-radius:4px;box-sizing:border-box;cursor:pointer;display:flex;height:40px;justify-content:space-between;overflow:hidden;padding:0 12px;}.gravity-dropdown-option--size-small{height:32px;padding:0 6px}.gravity-dropdown-option__side{align-items:center;display:flex;justify-content:center;max-width:fit-content;min-width:0}.gravity-dropdown-option__side:first-child{flex:4 1 0}.gravity-dropdown-option__side:last-child{flex:1 1 0;gap:4px;margin-left:4px}.gravity-dropdown-option__checkbox{margin-inline-end:6px;margin-top:-3px;pointer-events:none}.gravity-dropdown-option--size-small .gravity-dropdown-option__checkbox{margin-inline-end:4px}.gravity-dropdown-option--empty{color:rgba(0, 15, 30, 0.05);cursor:not-allowed}.gravity-dropdown-option--active:not(.gravity-dropdown-option--disabled){background-color:rgba(0, 15, 30, 0.05)}.gravity-dropdown-option--active.gravity-dropdown-option--empty{background-color:rgba(0, 15, 30, 0.05)}.gravity-dropdown-option--danger:hover{background-color:#FBE7EC}.gravity-dropdown-option:hover:not(.gravity-dropdown-option--disabled):not(.gravity-dropdown-option--active){background-color:rgba(0, 15, 30, 0.05)}.gravity-dropdown-option--danger.gravity-dropdown-option--active{background-color:#FBE7EC}.gravity-dropdown-option--disabled{cursor:not-allowed}.gravity-dropdown-option--disabled .gravity-dropdown-option__side ::slotted(*){opacity:0.4}.gravity-dropdown-option__title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";
const GravityDropdownOptionStyle0 = gravityDropdownOptionCss;

const GravityDropdownOption = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.generateClassNames = bem('gravity-dropdown-option');
        this.active = false;
        this.danger = false;
        this.disabled = false;
        this.meta = '';
        this.multi = false;
        this.optionId = '';
        this.optionTitle = '';
        this.selected = false;
        this.size = 'medium';
        this.sublevel = false;
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
    }
    composeTitle() {
        if (this.meta) {
            return `${this.optionTitle} • ${this.meta}`;
        }
        return this.optionTitle;
    }
    getTextColor() {
        if (this.disabled) {
            return 'dark-muted';
        }
        if (this.danger) {
            return 'negative';
        }
        if (this.sublevel === 'empty') {
            return 'dark-muted';
        }
        if (this.selected && !this.multi) {
            return 'primary-darker';
        }
        return 'dark';
    }
    renderMeta() {
        if (this.meta !== '') {
            return (h("gravity-text", { clamp: 1, color: this.disabled ? 'dark-muted' : 'dark-subtle', size: "xx-small", weight: "medium", class: this.generateClassNames('meta') }, this.meta));
        }
    }
    renderSelectedIcon() {
        if (this.selected) {
            const iconSize = this.size === 'small' ? 'xxx-small' : 'xx-small';
            return (h("gravity-icon", { name: "check", color: "primary-lighter", size: iconSize, class: this.generateClassNames('selected-icon') }));
        }
    }
    renderSublevelIcon() {
        if (this.sublevel) {
            return (h("gravity-icon", { name: "arrow-right-outline", color: "dark-subtle", size: "xxx-small", class: this.generateClassNames('sublevel-icon') }));
        }
    }
    render() {
        return (h("div", { key: 'ba1f0dbead6118f42490239118f4dcf2d36e809e', title: this.composeTitle(), class: this.generateClassNames({
                selected: this.selected,
                active: this.active,
                empty: this.sublevel === 'empty',
                danger: this.danger,
                [`size-${this.size}`]: true,
                disabled: this.disabled,
            }) }, h("div", { key: 'e66d082aeb213e3f062ce0587db8a4ad1662bdf3', class: this.generateClassNames('side') }, this.multi && !this.sublevel && (h("gravity-checkbox", { key: '3f85cd93f4b165da4686bd8e2e610b0fe7869bd4', class: this.generateClassNames('checkbox'), disabled: this.disabled, value: this.selected, tabindex: "-1" })), h("slot", { key: 'e22a5d8664b9c988473a0c8735af5728d4143095', name: "prefix" }), h("gravity-text", { key: '994eb392e44856b6944815e49642bc38117beea0', clamp: 1, class: this.generateClassNames('title'), color: this.getTextColor(), size: this.size === 'small' ? 'x-small' : 'small' }, this.optionTitle)), h("div", { key: '56f9a4a72853a3cf1335bf1a8e17e14eebdf7927', class: this.generateClassNames('side') }, this.renderMeta(), !this.multi && this.renderSelectedIcon(), this.renderSublevelIcon())));
    }
};
GravityDropdownOption.style = GravityDropdownOptionStyle0;

const gravityInputCss = ".gravity-input{display:flex;flex-direction:column}.gravity-input .clear-button{align-items:center;background:none;background-color:rgba(0, 15, 30, 0.1);border:0;border-radius:9999px;cursor:pointer;display:flex;justify-content:center;margin-left:6px;padding:0}.gravity-input .clear-button:focus{outline:none}.gravity-input .clear-button:hover,.gravity-input .clear-button:focus{background:rgba(0, 15, 30, 0.2)}.gravity-input .clear-button--hidden{pointer-events:none;visibility:hidden}.gravity-input__inner{align-items:center;background-color:var(--gravity-input-background-color, #FFFFFF);border-bottom:var(--gravity-input-border-bottom, 1px solid rgba(0, 15, 30, 0.2));border-left:var(--gravity-input-border-left, 1px solid rgba(0, 15, 30, 0.2));border-radius:var(--gravity-input-border-radius, 6px);border-right:var(--gravity-input-border-right, 1px solid rgba(0, 15, 30, 0.2));border-top:var(--gravity-input-border-top, 1px solid rgba(0, 15, 30, 0.2));box-sizing:border-box;cursor:text;display:flex;flex-direction:row}.gravity-input__inner:hover{border-color:rgba(0, 15, 30, 0.45)}.gravity-input__inner:focus-within{outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-input__inner-prepend .text,.gravity-input__inner-append .text{display:block}.gravity-input__inner-prepend{background-color:rgba(0, 15, 30, 0.05);border-radius:4px 0 0 4px;margin:0 12px 0 1px}.gravity-input__inner-append{background-color:rgba(0, 15, 30, 0.05);border-radius:0 4px 4px 0;margin:0 1px 0 12px;order:9}.gravity-input__inner .input{background-color:transparent;border:0;color:#000F1E;flex:1;font-family:\"Bull\", Helvetica, sans-serif;font-size:16px;font-weight:normal;line-height:1.5;overflow:hidden;padding:0;width:100%}.gravity-input__inner .input:invalid{box-shadow:none}.gravity-input__inner .input:focus{outline:none}.gravity-input__inner .input::placeholder{color:rgba(0, 15, 30, 0.4);font-weight:normal}.gravity-input__inner .input[type=password]{letter-spacing:3px}.gravity-input__inner .input[type=password]::placeholder{letter-spacing:normal}.gravity-input__inner .input::-webkit-outer-spin-button,.gravity-input__inner .input::-webkit-inner-spin-button{appearance:none;display:none}.gravity-input__inner .input[type=number]{appearance:textfield}.gravity-input--size-small.gravity-input--icon-left .input-icon{margin-right:4px}.gravity-input--size-small.gravity-input--icon-right .input-icon{margin-left:4px}.gravity-input--size-small .gravity-input__inner{border-radius:var(--gravity-input-border-radius, 4px);height:32px;padding:8px 8px}.gravity-input--size-small .gravity-input__inner .input{font-size:14px;line-height:1.428571}.gravity-input--size-small .gravity-input__inner-prepend{border-radius:2px 0 0 2px;margin-right:8px;padding:6px 8px}.gravity-input--size-small .gravity-input__inner-append{border-radius:0 2px 2px 0;margin-left:8px;padding:6px 8px}.gravity-input--size-medium .gravity-input__inner{height:40px;padding:8px 12px}.gravity-input--size-medium .gravity-input__inner-prepend,.gravity-input--size-medium .gravity-input__inner-append{padding:10px 8px}.gravity-input--invalid .gravity-input__inner{border-color:#DB0A40}.gravity-input--required .gravity-input__inner{border-color:#DB0A40}.gravity-input--icon-left .input-icon{margin-right:6px;order:1}.gravity-input--icon-left .input{order:5}.gravity-input--icon-left .clear-button{order:6}.gravity-input--icon-right .input-icon{margin-left:6px}.gravity-input--readonly .gravity-input__inner,.gravity-input--readonly .gravity-input__inner:hover,.gravity-input--readonly .gravity-input__inner:focus-within,.gravity-input--disabled .gravity-input__inner,.gravity-input--disabled .gravity-input__inner:hover,.gravity-input--disabled .gravity-input__inner:focus-within{background-color:rgba(0, 15, 30, 0.05);border-color:transparent}.gravity-input--disabled .gravity-input__inner .input{color:rgba(0, 15, 30, 0.4)}.gravity-input--highlighted .gravity-input__inner,.gravity-input--highlighted .gravity-input__inner:hover,.gravity-input--highlighted .gravity-input__inner:focus-within{background-color:#F4F8FE}.gravity-input--highlighted .gravity-input__inner .input,.gravity-input--highlighted .gravity-input__inner:hover .input,.gravity-input--highlighted .gravity-input__inner:focus-within .input{color:#175ACA}.gravity-input--prepend .gravity-input__inner{padding-left:0}.gravity-input--append .gravity-input__inner{padding-right:0}";
const GravityInputStyle0 = gravityInputCss;

const GravityInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.clear = createEvent(this, "clear", 7);
        this.inputChanged = createEvent(this, "inputChanged", 7);
        this.generateClassNames = bem('gravity-input');
        this.appendText = undefined;
        this.clearable = true;
        this.disabled = false;
        this.highlighted = false;
        this.iconName = undefined;
        this.iconPosition = 'right';
        this.infoBottom = false;
        this.infoPosition = 'top';
        this.infoText = '';
        this.infoWidth = undefined;
        this.inline = false;
        this.inlineLabelWidth = '33%';
        this.invalid = false;
        this.label = '';
        this.permanentClearable = false;
        this.placeholder = 'Enter a value';
        this.prependText = undefined;
        this.readonly = false;
        this.required = false;
        this.size = 'medium';
        this.spellcheck = false;
        this.type = 'default';
        this.validationMessage = undefined;
        this.value = '';
        this.showClearButton = this.permanentClearable && !!this.value && (!this.readonly || !this.disabled);
        this.valueMissing = false;
    }
    valueHandler() {
        if (this.input) {
            if (this.value) {
                this.input.value = this.value.toString().replace(this.prependText || this.appendText, '');
            }
            else if (this.type !== 'number') {
                // value is '' momentairly when '.' or ',' is typed in number input,
                // so we don't want to clear the input then
                this.input.value = '';
            }
        }
        this.showClearButton = !this.disabled && !this.readonly && !!this.value;
        this.validate();
    }
    requiredChangeHandler() {
        if (!this.required && this.valueMissing) {
            this.valueMissing = false;
        }
    }
    /**
     * Resets the input
     */
    async reset() {
        this.valueMissing = false;
        this.invalid = false;
        this.validationMessage = '';
        this.value = '';
        this.inputChanged.emit(this.value);
    }
    /**
     * Focuses the input field
     */
    async inputFocus() {
        this.input.focus();
    }
    validate() {
        if (this.required && this.value === '') {
            this.valueMissing = true;
        }
        else if (this.valueMissing) {
            this.valueMissing = false;
        }
    }
    renderInputIcon() {
        if (this.iconName) {
            const color = this.disabled ? 'dark-muted' : 'dark-subtle';
            return (h("gravity-icon", { size: this.size === 'small' ? 'xxx-small' : 'xx-small', color: color, class: "input-icon", name: this.iconName }));
        }
    }
    renderClearButton() {
        if (!this.clearable)
            return;
        return (h("button", { class: `
          clear-button
          ${!this.showClearButton ? 'clear-button--hidden' : ''}
        `, tabindex: -1, onClick: () => {
                this.clear.emit();
                this.input.value = '';
                this.handleChange();
            } }, h("gravity-icon", { class: "clear-button__icon", name: "close", color: "dark", size: "xxx-small" })));
    }
    renderPrependAppend() {
        if (!this.prependText && !this.appendText) {
            return;
        }
        const color = this.disabled ? 'dark-muted' : 'dark-subtle';
        return (h("div", { class: this.generateClassNames(`inner-${this.prependText ? 'prepend' : 'append'}`) }, h("gravity-text", { class: "text", color: color, size: "xx-small", weight: "medium" }, this.prependText || this.appendText)));
    }
    handleChange() {
        this.value = this.input.value;
        if (this.prependText && this.value) {
            this.value = this.prependText + this.value;
        }
        else if (this.appendText && this.value) {
            this.value += this.appendText;
        }
        this.inputChanged.emit(this.value);
    }
    getInputType() {
        switch (this.type) {
            case 'password':
                return 'password';
            case 'number':
                return 'number';
            default:
                return 'text';
        }
    }
    componentDidLoad() {
        /**
         * This is a temp fix for Last Pass issue of truthy attributes in input fields
         * for example: readonly="false" resolves to readonly
         * TODO: Remove this when Last Pass issue is fixed: https://github.com/redbullmediahouse/rbds-cosmos/issues/2951
         */
        attachObserverToInput(this.input, this.inputObserver);
        if (this.value) {
            this.input.value = this.value.toString().replace(this.prependText || this.appendText, '');
        }
        this.input.onfocus = () => {
            if (this.readonly || this.disabled) {
                return;
            }
            this.showClearButton = !!this.input.value;
        };
        this.element.onclick = () => {
            if (this.readonly || this.disabled) {
                return;
            }
            this.showClearButton = !!this.input.value;
            this.input.focus();
        };
        this.element.onmouseenter = () => {
            if (this.readonly || this.disabled) {
                return;
            }
            this.showClearButton = !!this.input.value;
        };
        this.element.onmouseleave = () => {
            if (this.element !== global$1.document.activeElement &&
                !this.permanentClearable &&
                !!this.input.value &&
                this.clearable) {
                this.showClearButton = false;
            }
        };
        this.element.onblur = () => {
            if (this.readonly || this.disabled) {
                return;
            }
            if (!this.permanentClearable && !!this.input.value) {
                this.showClearButton = false;
            }
            this.validate();
        };
    }
    disconnectedCallback() {
        if (this.inputObserver) {
            this.inputObserver.disconnect();
        }
    }
    render() {
        return (h(Host, { key: 'e54a187eaf30769093297625465bce5ae92e83f7' }, h("gravity-form-field", { key: 'd24910ca2ec7b8a1f79b593933d581454f554556', label: this.label, required: this.required, disabled: this.disabled, highlighted: this.highlighted, infoBottom: this.infoBottom, infoText: this.infoText, infoPosition: this.infoPosition, infoWidth: this.infoWidth, inline: this.inline, inlineLabelWidth: this.inlineLabelWidth, size: this.size, invalid: !!this.validationMessage || this.valueMissing, validationMessage: this.valueMissing ? 'This field is required' : this.validationMessage }, h("div", { key: '67dcdf646967e0484786e8dda0737be8c08a88c1', class: this.generateClassNames({
                size: this.size,
                type: this.type,
                icon: this.iconPosition,
                inline: this.inline,
                readonly: this.readonly,
                disabled: this.disabled,
                required: this.valueMissing,
                invalid: this.invalid || !!this.validationMessage,
                highlighted: this.highlighted,
                prepend: !!this.prependText,
                append: !!this.appendText && !this.prependText,
            }) }, h("div", { key: 'ad5ac12c8ee13abf513317c70b672882056868cb', class: this.generateClassNames('inner') }, this.renderPrependAppend(), h("input", { key: '24ee663bba19dcc13d0447506792aa099749b2b0', class: "input", spellcheck: this.spellcheck, type: this.getInputType(), placeholder: this.placeholder, required: this.required, readonly: this.readonly, disabled: this.disabled, onInput: () => this.handleChange(), ref: (el) => (this.input = el) }), this.renderClearButton(), this.renderInputIcon())))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["valueHandler"],
        "required": ["requiredChangeHandler"]
    }; }
};
GravityInput.style = GravityInputStyle0;

const gravitySearchCss = ".gravity-search{position:relative}.gravity-search--without-border .gravity-search__input{--gravity-input-border-top:none;--gravity-input-border-right:none;--gravity-input-border-bottom:none;--gravity-input-border-left:none;--gravity-input-background-color:transparent;--gravity-input-border-radius:0}.gravity-search__loader{background:#FFFFFF;display:inline-flex;left:12px;padding:1px;position:absolute;top:50%;transform:translateY(-50%)}.gravity-search--size-small .gravity-search__loader{left:8px}";
const GravitySearchStyle0 = gravitySearchCss;

const GravitySearch = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.clear = createEvent(this, "clear", 7);
        this.searchChange = createEvent(this, "searchChange", 7);
        this.generateClassNames = bem('gravity-search');
        this.busy = false;
        this.placeholder = 'Search';
        this.size = 'medium';
        this.type = 'default';
        this.value = '';
    }
    /**
     * Resets the input
     */
    async reset() {
        await this.input.reset();
    }
    /**
     * Focuses the input field
     */
    async inputFocus() {
        await this.input.inputFocus();
    }
    handleChange(event) {
        this.searchChange.emit(event.detail);
    }
    render() {
        return (h("div", { key: '132501e09ef1fe9da8155460ccddc375aed8c6bc', class: this.generateClassNames({
                'without-border': this.type == 'search-bar',
                'size': this.size,
            }) }, this.busy && (h("div", { key: 'ec9c32cb02759322d98006cf084faafb77f31baa', class: this.generateClassNames('loader') }, h("gravity-loading", { key: '2dee1baad7741ad84fef4a83b3ca3181413e3470' }))), h("gravity-input", { key: 'cef309b39a9129c7adc0f97065ccdf74a26d8074', class: this.generateClassNames('input'), value: this.value, placeholder: this.placeholder, size: this.size, "icon-name": "search", "icon-position": "left", type: 'default', onInputChanged: (event) => this.handleChange(event), ref: (el) => (this.input = el), permanentClearable: true, inline: true })));
    }
};
GravitySearch.style = GravitySearchStyle0;

export { GravityCheckbox as gravity_checkbox, GravityDropdown as gravity_dropdown, GravityDropdownInner as gravity_dropdown_inner, GravityDropdownOption as gravity_dropdown_option, GravityInput as gravity_input, GravitySearch as gravity_search };

//# sourceMappingURL=gravity-checkbox_6.entry.js.map